import * as React from 'react';
import { type IconButtonProps } from '@mui/material';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { useL2DTheme } from '@europrocurement/flexy-components/hooks';
import { deleteIcon } from '@europrocurement/l2d-icons';
import { FlexyIconButton, IconType } from '../FlexyIconButton';

export type ClearButtonProps = {
    size?: SizeProp;
    color?: IconButtonProps['color'];
    tooltip?: string;
    onClick?: IconButtonProps['onClick'];
    disabled?: IconButtonProps['disabled'];
    confirmation?: boolean;
    icon?: IconType;
};

export const ClearButton: React.FunctionComponent<ClearButtonProps> = function ({
    size,
    color,
    tooltip = 'Supprimer',
    onClick = undefined,
    disabled = false,
    confirmation = false,
    icon = undefined,
}: ClearButtonProps) {
    const { palette } = useL2DTheme();

    const iconToUse = icon ?? deleteIcon.props.icon;

    return (
        <FlexyIconButton
            icon={iconToUse}
            displayTooltip
            tooltipOverwriteProps={{
                title: tooltip,
            }}
            iconOverwriteProps={{
                color: color || palette.text.secondary,
                size: size || '2xs',
            }}
            confirmation={confirmation}
            confirmationTooltip="Cliquez pour confirmer la suppression"
            normalHoverColor={palette.error.main}
            onClick={onClick}
            disabled={disabled}
        />
    );
};
